import {
  buildPrescriptionSummary,
  getPrescriptionLabel,
} from "./exerciseFormatting";

/**
 * Turn prescription summary into labeled fields for printable stat grid.
 * @param {object} exercise
 * @returns {{ label: string, value: string }[]}
 */
export function buildPrescriptionFields(exercise) {
  const { type, summaryChips, detailRows } = buildPrescriptionSummary(exercise);
  const fields = [];

  for (const chip of summaryChips) {
    const colon = chip.indexOf(":");
    if (colon > 0) {
      fields.push({
        label: chip.slice(0, colon).trim(),
        value: chip.slice(colon + 1).trim(),
      });
    } else if (chip.trim()) {
      fields.push({ label: "Details", value: chip.trim() });
    }
  }

  for (const row of detailRows) {
    fields.push({ label: row.label, value: String(row.value) });
  }

  if (fields.length === 0) {
    fields.push({ label: "Prescription", value: getPrescriptionLabel(type) });
  }

  return fields;
}

export function resolveExerciseDisplayName(exercise, findById, getExerciseName) {
  return (
    exercise?.exerciseName ||
    findById(exercise?.exercise)?.name ||
    getExerciseName(exercise?.exercise) ||
    "Exercise"
  );
}
